// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignInButton_container__o-0ip {
    padding: 8px 20px;
    background: #1976d2;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.2s;
    font-weight: bold;
}
.SignInButton_container__o-0ip:hover {
    background: #1565c0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SignInButton/SignInButton.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".container {\r\n    padding: 8px 20px;\r\n    background: #1976d2;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: background 0.2s;\r\n    font-weight: bold;\r\n}\r\n.container:hover {\r\n    background: #1565c0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SignInButton_container__o-0ip`
};
export default ___CSS_LOADER_EXPORT___;
